import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const useTabPathNavigate = ({ availableTabs = [], baseRoute }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const initialTabIndex = availableTabs.indexOf(location.pathname)
  const [activeIndex, setActiveIndex] = useState(
    initialTabIndex === -1 ? 0 : initialTabIndex
  )
  const handleTabChange = (e) => {
    setActiveIndex(e.index)
    navigate(availableTabs[e.index])
  }

  useEffect(() => {
    const newIndex = availableTabs.indexOf(location.pathname)
    if (newIndex !== -1 && newIndex !== activeIndex) {
      setActiveIndex(newIndex)
    } else if (location.pathname === baseRoute) {
      navigate(availableTabs[activeIndex], { replace: true })
    }
  }, [location.pathname, activeIndex, availableTabs, navigate])

  return {
    activeIndex,
    handleTabChange,
    setActiveIndex,
  }
}

export default useTabPathNavigate
